<mat-card class="send-email-card">
  <mat-card-content class="card-content">
    <!-- Loading state -->
    @if (isLoading()) {
      <div class="loading-container">
        <div class="spinner-wrapper">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
          </div>
        </div>
      </div>
    }
    @else {
      <form [formGroup]="emailForm" novalidate class="activity-content">
      <div>
        <!-- Email-specific fields: To, Subject -->
        <glxy-form-row class="detail-form-row">
          <glxy-form-field
            bottomSpacing="small"
            [showLabel]="false"
            size="default"
            class="detail-form-field"
            [prefixIcon]="'email'"
          >
            <input
              formControlName="to"
              type="email"
              matInput
              [placeholder]="'CRM.EMAIL' | translate"
              [disabled]="isSending()"
              [readonly]="true"
            />
            @if (showErrors()) {
              @if (emailForm.controls.to.hasError('required')) {
                <glxy-error>
                  {{ 'CRM.EMAIL_IS_REQUIRED' | translate }}
                </glxy-error>
              }
            }
          </glxy-form-field>
          <glxy-form-field
            bottomSpacing="small"
            [showLabel]="false"
            class="detail-form-field"
            [prefixIcon]="'subject'"
          >
            <input
              #subjectInput
              formControlName="subject"
              type="text"
              matInput
              [placeholder]="'CRM.SUBJECT' | translate"
              [disabled]="isSending()"
            />
            @if (showErrors()) {
              @if (emailForm.controls.subject.hasError('required')) {
                <glxy-error>
                  {{ 'CRM.SUBJECT_IS_REQUIRED' | translate }}
                </glxy-error>
              }
            }
          </glxy-form-field>
        </glxy-form-row>
      
      </div>

      <div>
        <!-- Rich Text Editor Section -->
        <glxy-form-row class="detail-form-row">
          <glxy-rich-text-editor
            class="rich-text-editor"
            elementId="send-email-rte"
            formControlName="content"
            [statusbar]="true"
            [enableThemes]="true"
            [allowResize]="true"
            [plugins]="DEFAULT_RICH_TEXT_PLUGINS"
            [toolbar]="DEFAULT_RICH_TEXT_TOOLBAR"
            [disabled]="isSending()"
          ></glxy-rich-text-editor>
              @if (showErrors()) {
                @if (emailForm.controls.content.hasError('required')) {
                  <glxy-error>
                    {{ 'CRM.CONTENT_IS_REQUIRED' | translate }}
                  </glxy-error>
                }
              }
        </glxy-form-row>
      </div>

      </form>
    }
  </mat-card-content>

  <!-- Action Buttons -->
  @if (!isLoading()) {
    <mat-card-actions [align]="'start'" class="activity-form-actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="onSend()"
        [disabled]="isSending()"
      >
        <glxy-button-loading-indicator [isLoading]="isSending()">
          {{ 'CRM.SEND' | translate }}
        </glxy-button-loading-indicator>
      </button>
      <button 
        mat-stroked-button 
        (click)="onCancel()" 
        type="button"
        [disabled]="isSending()">
        {{ 'CRM.CANCEL' | translate }}
      </button>
    </mat-card-actions>
  }
</mat-card>